import { render } from "./Schedule.vue?vue&type=template&id=bb97ea20"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
script.render = render

export default script